import { useQuery } from '@tanstack/react-query';
import type { AdsPromptAd } from '@brand24-original/llm-types';
import { AdsFilters, getAdsPromptDetails } from '../../services/ads/AdsService';
import { GET_ADS_PROMPT_DETAILS } from '../../query/ads/keys';

/** Creatives detected at one prompt — fetched lazily when a By-prompt row is expanded. */
export const useGetAdsPromptDetails = (
  projectId: number | null,
  monitorId: number | null,
  from: Date | null,
  to: Date | null,
  filters: AdsFilters
) => {
  const queryEnabled = !!projectId && !!monitorId && !!from && !!to;

  const { data, isLoading, isError, refetch } = useQuery<AdsPromptAd[]>({
    queryKey: [
      GET_ADS_PROMPT_DETAILS,
      projectId,
      monitorId,
      from,
      to,
      filters.models,
      filters.promptIds,
      filters.advertisers,
    ],
    queryFn: () => getAdsPromptDetails(projectId!, monitorId!, from!, to!, filters),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
  });

  return {
    ads: queryEnabled ? data ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
